@if (isShow) {
  <div class="spinner-load-bar-wrapper" [ngClass]="{ 'full-page-spinner': isFullPage }">
    <div class="spinner-load-wrapper" id="spinner">
      <div class="loading-bar"></div>
      <div class="loading-bar"></div>
      <div class="loading-bar"></div>
      <div class="loading-bar"></div>
      <div class="loading-bar"></div>
    </div>
  </div>
}
